import "client-only";

import useMutation from "src/hooks/useMutation";

function useWarehouseDistributionDetaillCreate(params) {
  return useMutation({
    path: `/api/v1/warehouses/${params?.id}/distribution`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouses/${params?.id}/distribution`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseDistributionDetaillCreate;
